module.exports = __webpack_public_path__ + "static/media/paraco_novo.a7196ff6.png";